var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"},on:{"click":_vm.detectMotion,"mousemove":_vm.detectMotion,"keydown":_vm.detectMotion}},[_c('router-view'),_c('KeepAlive',[_c('Version',{ref:"version"})],1),_c('KeepAlive',[_c('Inactivity',{ref:"inactivity"})],1),_c('KeepAlive',[_c('OldHost',{ref:"oldhost"})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }